import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';
import { type FallbackProps } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { Breakpoint } from '../../../theme/breakpoints';

const messages = defineMessages({
  expired: {
    id: 'sharedResource.access.expiredLink',
    defaultMessage: 'This link has expired',
  },
  reshare: {
    id: 'sharedResource.access.reshare',
    defaultMessage:
      'If you still need access to this record, ask the sender to share it with you again',
  },
});

export default function SharedResourceExpiryErrorFallback(
  _props: FallbackProps
) {
  const { formatMessage } = useIntl();

  return (
    <Card sx={{ mt: 2, maxWidth: Breakpoint.SM }}>
      <CardHeader
        title={formatMessage(messages.expired)}
        titleTypographyProps={{
          variant: 'h6',
        }}
      />
      <Divider />
      <CardContent>
        <Typography color="text.secondary" variant="body1">
          {formatMessage(messages.reshare)}
        </Typography>
      </CardContent>
    </Card>
  );
}
